import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
export class AmdNavbarItemComponent {
    /**
     * @param {?} changeDetectorRef
     */
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.navbarItemThemeClass = 'amd-navbar__item--default';
    }
    /**
     * @param {?} theme
     * @return {?}
     */
    set theme(theme) {
        this.navbarItemThemeClass = `amd-navbar__item--${theme}`;
        this.changeDetectorRef.markForCheck();
    }
}
AmdNavbarItemComponent.decorators = [
    { type: Component, args: [{
                selector: 'amd-navbar-item',
                template: "<div class=\"amd-navbar__item\" [ngClass]=\"navbarItemThemeClass\"> <ng-content></ng-content> </div>",
                changeDetection: ChangeDetectionStrategy.OnPush
            },] },
];
/**
 * @nocollapse
 */
AmdNavbarItemComponent.ctorParameters = () => [
    { type: ChangeDetectorRef, },
];
AmdNavbarItemComponent.propDecorators = {
    'theme': [{ type: Input },],
};
function AmdNavbarItemComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdNavbarItemComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdNavbarItemComponent.ctorParameters;
    /** @type {?} */
    AmdNavbarItemComponent.propDecorators;
    /** @type {?} */
    AmdNavbarItemComponent.prototype.navbarItemThemeClass;
    /** @type {?} */
    AmdNavbarItemComponent.prototype.changeDetectorRef;
}
//# sourceMappingURL=navbar-item.component.js.map
//# sourceMappingURL=navbar-item.component.js.map
